import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./lab-test.scss"
import { useDispatch, useSelector } from 'react-redux';
import CreatableSearchSelect from '../../../common/updated-input/createble-search-select/creatable-search-select';
import { getAllLabTests } from '../../../../store/slices/prescriptionSlice';
import { patientLabTestAdd } from '../../../../service/api/patient-api';
import { addLabTest } from '../../../../service/api/medical-data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { prescriptionAddSubDocument, prescriptionAddSubDocumentArray, prescriptionRemoveSubDocument, prescriptionUpdateSubDocument } from '../../../../service/api/prescription';
import {
    templateAddSubDocument,
    templateRemoveSubDocument,
    templateUpdateSubDocument
} from '../../../../service/api/template';
import UniversalLoaderForComponent from '../../../loader/universalLoaderForComponent';
import { put } from '../../../../utils/fetchAPI';
import CreatableSearchSelectAntD from '../../../common/updated-input/createble-search-select/creatable-search-select-antd';
import { DraggableList } from '../../../common/draggable-list/drgabble-list';
import { Select } from 'antd';
import { getGroups, getGroupLabTests } from '../../../../service/api/group';
import { GROUPS_CHANGED_EVENT } from '../../../common/group-manager/group-manager';

const LabTest = ({ doctorId = "", templateId = "", visitDetails, updateState }) => {
    let { labTestList, isLabTestListLoading } = useSelector((state) => state.prescription);
    let { templateDetails } = useSelector((state) => state.template);
    let [prescribedLabTest, setPrescribedLabTest] = useState([])
    const [options, setOptions] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch()
    let timeoutIdRef = useRef()

    // The doctor whose lab test groups we read (assistant -> selected doctor).
    const labTestDoctorId = visitDetails?.doctor || doctorId
    const [groups, setGroups] = useState([])
    // bumped after each pick to remount (and thus reset) the group dropdown
    const [groupPickerKey, setGroupPickerKey] = useState(0)

    useEffect(() => {
        if (doctorId || visitDetails?.doctor) {
            const payLoad = { doctorId: visitDetails?.doctor || doctorId, search: '' }
            dispatch(getAllLabTests(payLoad))
        }
    }, [visitDetails?.doctor, doctorId])

    const loadGroups = async () => {
        if (!labTestDoctorId) return
        const res = await getGroups(labTestDoctorId, 'labTest')
        if (res?.status === 200) setGroups(res.data || [])
    }

    useEffect(() => {
        loadGroups()
        // refresh when groups are managed elsewhere (e.g. the section-gear modal)
        const onGroupsChanged = (e) => { if (e?.detail?.type === 'labTest') loadGroups() }
        window.addEventListener(GROUPS_CHANGED_EVENT, onGroupsChanged)
        return () => window.removeEventListener(GROUPS_CHANGED_EVENT, onGroupsChanged)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [labTestDoctorId])

    // Add every lab test in the chosen group to the current prescription (skips ones
    // already added). Works for both the visit and the template editor.
    const addGroupToVisit = async (groupId) => {
        if (!groupId) return
        setIsLoading(true)
        try {
            const res = await getGroupLabTests(labTestDoctorId, groupId)
            const groupLabTests = res?.status === 200 ? (res.data || []) : []
            const existingIds = new Set((prescribedLabTest || []).map((p) => p?.labTest?.toString?.() || p?.labTest))
            const toAdd = groupLabTests.filter((l) => l?.name && !existingIds.has(l._id))
            if (toAdd.length === 0) return

            if (templateId) {
                let last
                for (const l of toAdd) {
                    last = await templateAddSubDocument('labTests', { labTest: l._id, name: l.name }, templateId)
                }
                if (last?.status === 200) setPrescribedLabTest(last.data?.labTests)
            } else {
                const payload = toAdd.map((l) => ({ labTest: l._id, name: l.name }))
                const addRes = await prescriptionAddSubDocumentArray('labTests', payload, visitDetails?._id)
                if (addRes?.status === 200) {
                    setPrescribedLabTest(addRes.data?.labTests)
                    updateState(addRes.data)
                }
            }
        } finally {
            setIsLoading(false)
        }
    }

    const setOptionFun = (event) => {
        event.preventDefault()
        const payLoad = { doctorId: visitDetails?.doctor || doctorId, search: event.target.value }
        dispatch(getAllLabTests(payLoad))
    }

    const handleSubmit = (value) => {
        labTestAddFun(value?._id, value?.value)
    }

    const handleCreate = async (value) => {
        await addLabTest({ doctor: visitDetails?.doctor || doctorId, name: value })
            .then((res) => {
                if (res.status === 200) {
                    labTestAddFun(res?.data?._id, res?.data?.name)
                    const payLoad = { doctorId: visitDetails?.doctor || doctorId, search: '' }
                    dispatch(getAllLabTests(payLoad))
                }
            })
    }

    const labTestAddFun = async (labTestId, labTestName) => {
        setIsLoading(true)
        if (!templateId) {
            const payLoad = {
                labTest: labTestId,
                name: labTestName
            }

            await prescriptionAddSubDocument('labTests', payLoad, visitDetails?._id)
                .then((res) => {
                    if (res.status === 200) {
                        setPrescribedLabTest(res?.data?.labTests)
                        updateState(res?.data)
                        // prescriptionRefresh()
                    }
                })
                .finally(() => { setIsLoading(false) })

        }
        else if (templateId) {
            const payLoad = {
                labTest: labTestId,
                name: labTestName
            }

            if (templateId) {
                await templateAddSubDocument('labTests', payLoad, templateId)
                    .then((res) => {
                        if (res.status === 200) {
                            setPrescribedLabTest(res?.data?.labTests)
                        }
                    })
                    .finally(() => { setIsLoading(false) })
            }
        }

    }


    const deleteLabTestFun = async (labTest) => {
        setIsLoading(true)
        if (!templateId) {
            await prescriptionRemoveSubDocument('labTests', { _id: labTest?._id }, visitDetails?._id)
                .then((res) => {
                    if (res?.status === 200) {
                        setPrescribedLabTest(res?.data?.labTests)
                        updateState(res?.data)
                    }
                }).finally(() => { setIsLoading(false) })
        }
        else if (templateId) {
            await templateRemoveSubDocument('labTests', { _id: labTest?._id }, templateId)
                .then((res) => {
                    if (res?.status === 200) {
                        setPrescribedLabTest(res?.data?.labTests)
                    }
                }).finally(() => { setIsLoading(false) })
        }
    }

    useMemo(() => {
        if (visitDetails?.labTests) {
            setPrescribedLabTest(visitDetails?.labTests)
        } else if (templateId) {
            setPrescribedLabTest(templateDetails?.labTests)
        }
    }, [visitDetails?.labTests, templateDetails])


    const labTestEdit = async (value, labTest, index, isUpdate) => {
        let oldLabTests = [...prescribedLabTest]
        let current = {}
        if (oldLabTests[index])
            current = oldLabTests[index]
        current = { ...current, name: value }
        oldLabTests[index] = current
        setPrescribedLabTest([...oldLabTests])
        clearTimeout(timeoutIdRef.current);

        // timeoutIdRef.current = setTimeout(async () => {
        let payLoad = {}
        payLoad._id = labTest?._id
        payLoad[`labTests.$.name`] = value

        if (isUpdate) {
            if (templateId) {
                await templateUpdateSubDocument("labTests", payLoad, templateId).
                    then((res) => {
                        if (res.status == 200) {
                            setPrescribedLabTest(res?.data?.labTests)
                            updateDoctorLabTest(labTest?.labTest, value, visitDetails?.doctor || doctorId)
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally()
            }
            else {
                await prescriptionUpdateSubDocument("labTests", payLoad, visitDetails?._id).
                    then((res) => {
                        if (res.status == 200) {
                            setPrescribedLabTest(res?.data?.labTests)
                            updateState(res?.data)
                            updateDoctorLabTest(labTest?.labTest, value, visitDetails?.doctor || doctorId)
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally()
            }
        }

        // }, 1000);
    }

    const onChangeLabtestList = (sortedList) => {
        setPrescribedLabTest(sortedList)
        setSwapMedicinesToVisit(sortedList)
    }

    const setSwapMedicinesToVisit = async (labTests) => {

        // clearTimeout(timeoutIdRef.current);
        if (templateId) {
            // timeoutIdRef.current = setTimeout(async () => {
            await put(`/doctor/template/${templateId}`, { "labTests": labTests })
                .then((res) => {
                    if (res.status === 200) {
                        updateState(res?.data)
                        setPrescribedLabTest(res?.data?.labTests)
                    }
                })
                .catch((e) => { })
                .finally(() => { })
            // }, 1500);
        } else {
            // timeoutIdRef.current = setTimeout(async () => {
            await put(`/visit/${visitDetails?._id}`, { "labTests": labTests })
                .then((res) => {
                    if (res.status === 200) {
                        updateState(res?.data)
                        setPrescribedLabTest(res?.data?.labTests)
                    }
                })
                .catch((e) => { })
                .finally(() => { })
            // }, 1500);
        }
    }


    const updateDoctorLabTest = async (labTestId, name, doctorId) => {
        await put(`doctor/lab-test/update`, { labTestId: labTestId, name: name, doctorId: doctorId }).
            then((res) => {
                if (res.status == 200) {
                    const payLoad = { doctorId: visitDetails?.doctor || doctorId, search: '' }
                    dispatch(getAllLabTests(payLoad))
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally()
    }

    useMemo(() => {
        let allLabtests = []
        if (labTestList?.length > 0) {
            labTestList?.map((data) => {
                if (data?.name?.trim()?.length > 0)
                    allLabtests.push({ value: JSON.stringify({ _id: data?._id, value: data?.name }), label: data?.name })
            })
            setOptions(allLabtests)
        }
    }, [labTestList])

    return (
        <div>
            {groups?.length > 0 && (
                <div style={{ marginBottom: '6px' }}>
                    <Select
                        key={groupPickerKey}
                        size="large"
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Add all investigations from a group"
                        onChange={(val) => { addGroupToVisit(val); setGroupPickerKey((k) => k + 1); }}
                        options={groups.map((g) => ({ label: g.name, value: g._id }))}
                    />
                </div>
            )}
            <CreatableSearchSelectAntD customClass='custom-color-border-1' placeHolderColor="#13AC81" handleSubmit={handleSubmit} handleCreate={handleCreate} isSearching={isLabTestListLoading} setOptionFun={setOptionFun} options={options} placeHolder='Search labtest'></CreatableSearchSelectAntD>

            <div className='sub-section-list'>
                {prescribedLabTest?.length > 0 ? (
                    <DraggableList
                        items={prescribedLabTest}
                        onReorder={onChangeLabtestList}
                        getItemId={(item) => item?._id}
                        renderItem={(labTest, index) => (
                            <div key={labTest?._id} className='sub-item-row'>
                                <span className='sub-index'>{index + 1}</span>
                                <textarea
                                    style={{ resize: "vertical" }}
                                    autoComplete="off"
                                    placeholder="Lab test name"
                                    rows={2}
                                    onChange={(e) => { labTestEdit(e.target.value, labTest, index) }}
                                    value={labTest?.name}
                                    onBlur={(e) => { labTestEdit(e.target.value, labTest, index, true) }}
                                />
                                <button className='sub-del' onClick={() => deleteLabTestFun(labTest)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </div>
                        )}
                    />
                ) : null}
                {isLoading && <UniversalLoaderForComponent></UniversalLoaderForComponent>}
            </div>
        </div>
    )
}

export default LabTest
